module.exports = __webpack_public_path__ + "img/16_Fachfrau_Apotheke_Foto.5c5ef92a.jpg";